import * as Yup from 'yup';

export const loginValidationSchema = Yup.object({
  mobile: Yup.string()
    .required('Email/Mobile is required')
    .test('email-or-mobile', 'Please enter a valid email or mobile number', (value) => {
      if (!value) return false;
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[0-9]{10}$/;
      
      return emailRegex.test(value) || mobileRegex.test(value);
    }),
  password: Yup.string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters'),
});

export const forgotPasswordValidationSchema = Yup.object({
  mobile: Yup.string()
    .required('Email/Mobile is required')
    .test('email-or-mobile', 'Please enter a valid email or mobile number', (value) => {
      if (!value) return false;
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[0-9]{10}$/;
      
      return emailRegex.test(value) || mobileRegex.test(value);
    }),
});

export const resetPasswordValidationSchema = Yup.object({
  newPassword: Yup.string()
    .required('New password is required')
    .min(6, 'Password must be at least 6 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      'Password must contain at least one uppercase letter, one lowercase letter, and one number'
    ),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
});